import React, { useState, useEffect } from 'react';
import { Button, Modal } from 'react-bootstrap';

const AddDeliveryPoint = ({ show, onClose, onSuccess  }) => {
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState(new Set());
  const [preparationCategoryName, setPreparationCategoryName] = useState('');
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (show) {
      fetch(`${baseURL}/manage-items/active`)
        .then((res) => res.json())
        .then((data) => {
          if (data && data.data) {
            setItems(data.data);
          }
        })
        .catch((error) => {
          console.error('Failed to fetch items:', error);
        });
    }
  }, [show, baseURL]);

  const toggleItemSelection = (sno) => {
    setSelectedItems((prevSelected) => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(sno)) {
        newSelected.delete(sno);
      } else {
        newSelected.add(sno);
      }
      return newSelected;
    });
  };

  const handleSubmit = async () => {
    setErrorMsg(null);

    if (!preparationCategoryName.trim()) {
      setErrorMsg('Preparation Category name is required.');
      return;
    }

    if (selectedItems.size === 0) {
      setErrorMsg('Please select at least one item.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(`${baseURL}/preparation-category`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          preparationcategory_name: preparationCategoryName.trim(),
          items: Array.from(selectedItems),
        }),
      });

      if (response.ok) {
        setSuccessMsg('Preparation category created successfully!');
        setTimeout(() => {
          onClose();
          if (onSuccess) onSuccess(); 
          setPreparationCategoryName('');
          setSelectedItems(new Set());
          // successMsg remains to show outside if you want
        }, 1500);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} size="md" onHide={onClose}>
      <div className="modal-content">
        <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
          <h3 className="modal-title text-white">Create Preparation Category</h3>
          <Button variant="" type="button" className="close px-6 py-2" onClick={onClose}>
            <span className="text-white">×</span>
          </Button>
        </div>
        <div className="modal-body">
          <div className="row">
            <div className="col-lg-12 mb-2">
              <label className="text-black font-w500 fs-7">
                Preparation Category <span className="required">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Preparation Category"
                value={preparationCategoryName}
                 onChange={e => {
                    const input = e.target.value;
                    const formatted = input
                      .toLowerCase()
                      .split(' ')
                      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                      .join(' ');
                    setPreparationCategoryName(formatted);
                  }}
                disabled={loading}
              />
              {errorMsg === 'Preparation Category name is required.' && (
                <span className="text-danger fs-7">{errorMsg}</span>
              )}
            </div>
          </div>

          <div className="row mt-2">
            <label className="text-red font-w500 fs-6 mb-1">Select Items</label>
            
            <div className="scroll-y mh-350px py-2">
              <div className="row">
                {items.length === 0 && <p>Loading items...</p>}
                {items.map((item) => (
                  <div
                    key={item.sno}
                    className="col-lg-6 mb-2 d-flex align-items-center"
                  >
                    <input
                      className="form-check-input me-3"
                      type="checkbox"
                      id={`item-${item.sno}`}
                      value={item.sno}
                      checked={selectedItems.has(item.sno)}
                      onChange={() => toggleItemSelection(item.sno)}
                      disabled={loading}
                    />
                    <label className="fs-7 text-black font-w500 mt-1" htmlFor={`item-${item.sno}`}>
                      {item.item_name}
                    </label>
                  </div>
                ))}
              </div>
            </div>
            {errorMsg === 'Please select at least one item.' && (
              <span className="text-danger fs-7 mb-2 d-block">{errorMsg}</span>
            )}
          </div>
 

          <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
            <Button variant="primary" onClick={handleSubmit} disabled={loading}>
              {loading ? 'Submitting...' : (
                <>
                  Create Preparation Category <i className="fas fa-angle-double-right ms-2"></i>
                </>
              )}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddDeliveryPoint;
